import { Instagram, Facebook, Youtube, Music2, Sparkles } from "lucide-react";

const SOCIALS = [
  { id: "ig", label: "Instagram", icon: Instagram, url: "https://www.instagram.com/scootive" },
  { id: "fb", label: "Facebook", icon: Facebook, url: "https://www.instagram.com/scootive_com/" },
  { id: "tt", label: "TikTok", icon: Music2, url: "https://www.tiktok.com/@scootive_com" },
  { id: "yt", label: "YouTube", icon: Youtube, url: "https://www.youtube.com/scootivetv" },
];

export default function NoCampaignHero() {
  return (
    <div data-testid="no-campaign-hero" className="w-full flex flex-col items-center">
      <div className="rise-in rise-2 inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-brand-green/8 text-brand-green text-[10px] font-medium uppercase tracking-[0.3em]">
        <Sparkles className="w-3 h-3" />
        Stay tuned
      </div>

      <h1
        data-testid="no-campaign-headline"
        className="rise-in rise-2 mt-5 font-display text-[44px] sm:text-6xl uppercase tracking-tight leading-[0.92]"
      >
        Wróć wkrótce
      </h1>

      <p className="rise-in rise-3 mt-4 text-[14px] sm:text-[15px] text-black/55 leading-relaxed max-w-md mx-auto">
        Aktualnie nie trwa żadne głosowanie. Trwają przygotowania do kolejnej trasy —
        śledź nasze profile, żeby nie przegapić startu.
      </p>

      {/* Big social grid (card-like) */}
      <div className="rise-in rise-4 w-full mt-8 max-w-md">
        <p className="text-[10px] font-medium uppercase tracking-[0.3em] text-black/40 mb-3">
          Dołącz do crew
        </p>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-2.5">
          {SOCIALS.map(({ id, label, icon: Icon, url }) => (
            <a
              key={id}
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`social-${id}`}
              className="group surface-soft p-4 flex flex-col items-center gap-2 hover:bg-brand-green/[0.04] transition-all hover:-translate-y-0.5"
            >
              <Icon className="w-5 h-5 text-black/65 group-hover:text-brand-green transition-colors" />
              <span className="text-[11px] font-semibold uppercase tracking-wider text-black/65 group-hover:text-brand-green transition-colors">
                {label}
              </span>
            </a>
          ))}
        </div>
      </div>

      <p className="rise-in rise-5 mt-7 text-[10px] uppercase tracking-[0.3em] text-black/30">
        www.scootive.pl
      </p>
    </div>
  );
}
